import { register } from "./registry";

register((root) => {
  root.querySelectorAll<HTMLFormElement>("form[data-adjustment-note]").forEach((form) => {
    if (form.dataset.referenceBound === "1") return;
    form.dataset.referenceBound = "1";
    // Module doc §3 row 2: Note Type defaults from the menu; picking the other type opens that note's screen (own series and number).
    const noteType = form.querySelector<HTMLSelectElement>("[data-note-type-switch]");
    noteType?.addEventListener("change", () => {
      if (noteType.value !== form.dataset.noteType) window.location.href = `/Accounts/AdjustmentNotes/Entry/${noteType.value}`;
    });
    const type = form.querySelector<HTMLSelectElement>("[name='RefDocType']");
    const series = form.querySelector<HTMLInputElement>("[name='RefSeries']");
    const number = form.querySelector<HTMLInputElement>("[name='RefNo']");
    const id = form.querySelector<HTMLInputElement>("[name='RefDocId']");
    const allocate = form.querySelector<HTMLInputElement>("[name='AllocateToRef']");
    const strip = form.querySelector<HTMLElement>("[data-reference-strip]");
    if (!type || !series || !number || !id || !allocate || !strip) return;

    const sync = () => {
      const bilti = type.value === "Bilti";
      series.setAttribute("aria-disabled", String(!type.value));
      number.setAttribute("aria-disabled", String(!type.value));
      allocate.setAttribute("aria-disabled", String(!bilti || form.dataset.noteType !== "credit"));
      if (!bilti || form.dataset.noteType !== "credit") allocate.checked = false;
      if (!type.value) { id.value = ""; strip.hidden = true; }
    };

    const load = async () => {
      if (!type.value || !number.value.trim()) return;
      const q = new URLSearchParams({ handler: "Reference", BranchId: form.querySelector<HTMLSelectElement>("[name='BranchId']")?.value ?? "", RefDocType: type.value, RefSeries: series.value, RefNo: number.value });
      const response = await fetch(`${location.pathname}?${q}`);
      const data = await response.json();
      if (!response.ok) {
        id.value = "";
        strip.hidden = false;
        strip.textContent = data.message ?? "Reference not found";
        number.focus(); number.select();
        return;
      }
      id.value = data.id;
      const partyLedger = form.querySelector<HTMLInputElement>("[name='LedgerId']")?.value;
      if (partyLedger && data.partyLedgerId && partyLedger.toLowerCase() !== String(data.partyLedgerId).toLowerCase()) {
        id.value = ""; strip.hidden = false; strip.textContent = "Reference party does not match the selected Party Ledger"; number.focus(); number.select(); return;
      }
      strip.hidden = false;
      strip.textContent = `${data.fullNo} · Miti ${data.miti} · ${data.party} · Taxable ${Number(data.taxable).toFixed(2)} · VAT ${Number(data.vat).toFixed(2)} · Total ${Number(data.total).toFixed(2)} · Open ${Number(data.openBalance).toFixed(2)}`;
      allocate.focus();
    };

    const invalidate = () => { id.value = ""; strip.hidden = true; };
    type.addEventListener("change", () => { invalidate(); sync(); });
    series.addEventListener("input", invalidate);
    number.addEventListener("input", invalidate);
    form.querySelector("[name='BranchId']")?.addEventListener("change", invalidate);
    number.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" || !type.value || !number.value.trim()) return;
      event.preventDefault(); event.stopPropagation(); void load();
    });
    sync();
  });
});
